import React from "react"
import { useHistory } from "react-router-dom"
import { formatNumber } from "@ncs/ts-utils"
import { BoxProps } from "../layout"
import { Paragraph } from "../typography"
import { Skeleton } from "@material-ui/lab"
import { Chip } from "../chips"
import { Box } from "@material-ui/core"

export interface ResultCountSummaryEcommProps extends BoxProps {
	currentTotal: number
	totalResults: number | null
	resultsAreApproximate?: boolean
	resultWord?: string
	searchItem?: string | null
	correctedTerm?: string | null
	correctedTerms?: string[]
	originalTerm?: string | null
	match?: boolean
}

export const ResultCountSummaryEcomm: React.FC<ResultCountSummaryEcommProps> = ({
	currentTotal,
	totalResults,
	resultsAreApproximate,
	resultWord = "result",
	searchItem,
	correctedTerm,
	correctedTerms,
	originalTerm,
	match,
}) => {
	const showAutoCorrectionMessage =
		match === false &&
		totalResults !== null &&
		totalResults > 0 &&
		originalTerm &&
		correctedTerm

	const showGibberishMessage =
		match === false && totalResults !== null && totalResults === 0 && originalTerm

	const suggestedTerms = correctedTerms && correctedTerms.length > 0 ? correctedTerms : []

	const history = useHistory()

	const handleClick = (term: string) => {
		const searchParams = new URLSearchParams()
		searchParams.set("page", "1")
		searchParams.set("search", JSON.stringify(term))
		history.push({
			pathname: "/shop/search/",
			search: searchParams.toString(),
		})
	}

	return (
		<>
			{totalResults === null ?
				<Skeleton />
			:	<>
					<Paragraph bold fontSize={1.5} customColor="#374151">
						Search Results{searchItem ? `: ${searchItem}` : ""}
					</Paragraph>
					<Paragraph css={{ marginTop: "0.25rem" }}>
						Showing {formatNumber(currentTotal)}{" "}
						{resultsAreApproximate && "approximately"} of {formatNumber(totalResults)}{" "}
						{resultWord}
						{totalResults !== 1 ? "s" : ""}
					</Paragraph>

					{showAutoCorrectionMessage && (
						<Paragraph css={{ fontSize: "1rem", marginTop: "1rem" }}>
							{originalTerm} not found. Showing results for "{correctedTerm}".
						</Paragraph>
					)}

					{showGibberishMessage && (
						<>
							<Paragraph css={{ fontSize: "1rem", marginTop: "1rem" }} bold>
								Sorry, we found no results for "{originalTerm}".
							</Paragraph>
							{suggestedTerms.length > 0 && (
								<>
									<Paragraph
										css={{
											fontSize: "0.875rem",
											marginBottom: "0.5rem",
											marginTop: "0.75rem",
										}}
										bold
									>
										Did you mean:
									</Paragraph>
									<Box
										display="flex"
										style={{ gap: "0.5rem", flexWrap: "wrap" }}
									>
										{suggestedTerms.map((term) => (
											<Chip
												key={term}
												css={{
													background: "#F1F6FE",
													borderColor: "transparent",
													fontWeight: "700",
													color: "#0B75E1",
													cursor: "pointer",
												}}
												label={term}
												onClick={() => handleClick(term)}
											/>
										))}
									</Box>
								</>
							)}
						</>
					)}
				</>
			}
		</>
	)
}
